<template>
  <div class="rowForm">
    <div class="rowForm-title">
      ПАРАМЕТРЫ РЯДА
    </div>
    <div class="rowForm-legend">
      Стойки
      <Info>
        выбор общей стойки уменьшает максимальную нагрузку на полку и стеллаж
      </Info>
    </div>
    <div class="rowForm-field">
      <Radio
        v-model="separate"
        :value="true"
      >
        Отдельные стойки
      </Radio>
      <br>
      <Radio
        v-model="separate"
        :value="false"
      >
        Общие стойки
      </Radio>
    </div>
    <div class="rowForm-legend">
      Размеры
      <Info>
        Высота и глубина являются общими для всего ряда, а длина выбирается индивидуально для каждого стеллажа на следующем шаге.
      </Info>
    </div>
    <div class="rowForm-field">
      <label>Высота стеллажей</label>
      <Select
        v-model="height"
        :options="options.height"
      />
    </div>
    <div class="rowForm-field">
      <label>Глубина стеллажей</label>
      <Select
        v-model="depth"
        :options="options.depth"
      />
    </div>
    <button @click="$emit('submit', $data)">
      {{ isNew ? 'Создать' : 'Применить' }}
    </button>
  </div>
</template>

<script>
  import Info from './Info';
  import Radio from './Radio';
  import Select from './Select';

  export default {
    name: 'RowForm',
    inject: {
      options: 'options',
    },
    components: {
      Info,
      Radio,
      Select,
    },
    props: {
      data: Object,
      isNew: Boolean,
    },
    data() {
      return {
        separate: true,
        height: 0,
        depth: 0,
        width: 0,
        count: 0,
        ...this.data,
      };
    },
  }
</script>

<style scoped>
  .rowForm {
    padding: 32px;
    width: 264px;
    background: #F6F6F6;
  }
  .rowForm-title {
    font-family: Oswald, Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    text-transform: uppercase;
    color: #A7A7A7;
  }
  .rowForm-legend {
    margin-top: 32px;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .rowForm-field {
    margin: 22px 0 30px;
  }
  select {
    margin-top: 10px;
    width: 100%;
  }
</style>
